import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMerchantFrontPageInfo } from "@/api/dashboard";
export default {
  name: 'Dashboard',
  data: function data() {
    return {
      totalOrder: true,
      successfulOrders: false,
      successRate: false,
      successfulAmount: false,
      payment: true,
      payout: false,
      todayDeposit: 0,
      waitSettlementAmount: 0,
      lastSettlementAmount: 0
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.getFrontPageInfo();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getFrontPageInfo: function getFrontPageInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getMerchantFrontPageInfo();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.waitSettlementAmount = res.data.WaitSettlementAmount;
                _this2.todayDeposit = res.data.todayDeposit;
                _this2.lastSettlementAmount = res.data.lastSettlementAmount;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    totalOrderClick: function totalOrderClick() {
      this.successfulAmount = false;
      this.successRate = false;
      this.successfulOrders = false;
      this.totalOrder = true;
    },
    successfulAmountClick: function successfulAmountClick() {
      this.successfulAmount = true;
      this.successRate = false;
      this.successfulOrders = false;
      this.totalOrder = false;
    },
    successRateClick: function successRateClick() {
      this.successfulAmount = false;
      this.successRate = true;
      this.successfulOrders = false;
      this.totalOrder = false;
    },
    successfulOrdersClick: function successfulOrdersClick() {
      this.successfulAmount = false;
      this.successRate = false;
      this.successfulOrders = true;
      this.totalOrder = false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$nextTick(function () {
      _this3.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'none';
      _this3.$refs.tabs.$children[0].$refs.tabs[0].style.border = 'none';
      console.log(_this3.$refs.tabs.$children[0].$refs);
      console.log(_this3.$refs.tabs.$children[0].$refs.tabs);
    });
  }
};